var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.value.filter, function (filter, index) {
    return _c('div', {
      key: "filter-card-pagination-value-field-".concat(filter.key, "-").concat(index),
      staticClass: "mb-1"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, [filter && _vm.isComparatorSelection ? _c('div', {
      staticStyle: {
        "width": "45px",
        "flex": "0",
        "margin-right": "2px",
        "margin-left": "2px"
      }
    }, [_vm.isComparatorSelection ? _c('v-select', {
      attrs: {
        "items": _vm.availableOperations,
        "hide-details": "",
        "data-test-filter-operation": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append",
        fn: function fn() {
          return [_c('div', {
            staticStyle: {
              "display": "none"
            }
          })];
        },
        proxy: true
      }, {
        key: "item",
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_c('v-spacer'), _vm._v(" " + _vm._s(_vm.$t("components.filter.".concat(item))) + " "), _c('v-spacer')];
        }
      }, {
        key: "selection",
        fn: function fn(_ref2) {
          var item = _ref2.item;
          return [_c('v-spacer'), _c('span', {
            staticStyle: {
              "position": "relative",
              "left": "2px"
            }
          }, [_vm._v(" " + _vm._s(_vm.$t("components.filter.".concat(item))) + " ")]), _c('v-spacer')];
        }
      }], null, true),
      model: {
        value: filter.operation,
        callback: function callback($$v) {
          _vm.$set(filter, "operation", $$v);
        },
        expression: "filter.operation"
      }
    }) : _vm._e()], 1) : _vm._e(), _c('filter-card-pagination-value-field', {
      staticStyle: {
        "flex-grow": "1"
      },
      attrs: {
        "filterConfiguration": _vm.value.filterOption,
        "outlined": true,
        "supressRequired": true
      },
      on: {
        "input": function input($event) {
          return _vm.$emit('input', _vm.value);
        }
      },
      model: {
        value: filter.value,
        callback: function callback($$v) {
          _vm.$set(filter, "value", $$v);
        },
        expression: "filter.value"
      }
    }), _c('v-btn', {
      staticClass: "ml-1",
      attrs: {
        "outlined": "",
        "height": "56",
        "min-width": "37",
        "data-test-filter-remove": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeFilter(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-trash-can")])], 1)], 1)]);
  }), !(_vm.isBooleanFilter && _vm.value.filter.length === 1) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.addFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }